var alignment_rtlignore_default = {
  "alignLeft": "pdewo",
  "textWrapNowrap": "wA3qH",
  "alignRight": "g0-PO",
  "alignCenter": "myQ2F",
  "sizeFullWidth": "_0IcAs",
  "renderedInTable": "U-B0F",
  "sizeOriginal": "_2Qapz",
  "sizeContent": "_3juyc",
  "sizeSmall": "sCRes",
  "sizeSmallCenter": "uTKQb",
  "flex": "rEpK0",
  "LEFT": "uBdr8",
  "CENTER": "Hc-7-",
  "RIGHT": "_6NaHm",
  "AUTO": "bIc1y",
  "JUSTIFY": "n69j1"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
